var path = '/glow/component/glow-vote/tpl/glow-vote.html';
var html = " <div class=\"glow-vote text-center\" ng-class=\"{'voted' : $ctrl.voteConfig.votes[$ctrl.item.id]}\" ng-style=$ctrl.styles.button ng-click=$ctrl.voteOnClick()> <span class=glow-vote-text>{{ $ctrl.voteConfig.votes[$ctrl.item.id] === true ? $ctrl.voteConfig.voteButtonCtaCompleteText : $ctrl.voteConfig.voteButtonCtaText }}</span> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-vote/tpl/glow-vote.html
// module id = 1727
// module chunks = 1